import React from "react";
import { useParams } from "react-router-dom";
import { Flag } from "lucide-react";
import { PageHeader } from "../../components/common";
import { FlaggedPaymentsPanel } from "../../components/FlaggedPaymentsPanel";
import { ReadOnlyNotice } from "../../components/FeatureGate";
import { useRoleModules } from "../../lib/roleModules";

/**
 * Phase 190 — Municipal Admin › Reports › Flagged Payments.
 * Every payment recorded above the amount payable (collector entry with reason Wrong Demand / Other, or a bulk-import row
 * above the demand due) lands here. The admin reviews it, corrects the demand (Phase 188 dialog) or marks it reviewed —
 * the excess stays as advance credit either way until the demand catches up.
 */
export default function FlaggedPayments() {
  const { code } = useParams();
  const access = useRoleModules(code);
  const readOnly = access.loaded && !access.canWrite("reports", "flagged_payments");
  return (
    <div data-testid="admin-flagged-payments-page">
      <PageHeader title="Flagged Payments"
        subtitle="Payments recorded above the amount payable — review each one, correct the demand or mark it reviewed. Everything is written to the Audit Trail.">
        <span className="inline-flex items-center gap-1.5 text-xs text-muted-foreground"><Flag className="h-3.5 w-3.5" /> Wrong Demand · Other · Bulk Import Excess</span>
      </PageHeader>
      {readOnly && <ReadOnlyNotice what="flagged payments" testId="flagged-payments-readonly-notice" className="mb-4" />}
      <FlaggedPaymentsPanel code={code} mode="tenant" testId="admin-flagged" readOnly={readOnly}
        propertyLink={(f) => `/${code}/admin/properties?focus=${f.property_id}`} />
    </div>
  );
}
